import dayjs from 'dayjs';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { ICompany } from 'app/shared/model/company.model';
import { IVehiclePosition } from 'app/shared/model/vehicle-position.model';

export interface IFifthWheelHistory {
  id?: number;
  createdStart?: string | null;
  createdEnd?: string | null;
  vehicle?: ITruckImplement | null;
  trailer?: ITruckImplement | null;
  company?: ICompany | null;
  positionStart?: IVehiclePosition | null;
  positionEnd?: IVehiclePosition | null;
}

export const defaultValue: Readonly<IFifthWheelHistory> = {};
